// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1haYM","footer":"ChangeClinic_footer__1939L"};